import request from "@/utils/request";
import qs from "qs";

// role
export function getRoleList(params) {
  return request.get("/api/v3/column_hybrid/douyin/role_list", { params });
}

export function allModuleList() {
  return request.get("/api/v3/column_hybrid/douyin/all_module_list");
}

export function getModuleList(loginId, params) {
  return request.get(`/api/v3/column_hybrid/douyin/${loginId}/module_list`, {
    params,
  });
}

export function getRoleShow(roleId, params) {
  return request.get(`/api/v3/column_hybrid/douyin/${roleId}/role_show`, {
    params,
  });
}

export function createRole(data) {
  return request({
    url: `/api/v3/column_hybrid/douyin/role_create`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function updateRole(roleId, params) {
  return request({
    url: `/api/v3/column_hybrid/douyin/${roleId}/role_update`,
    method: "post",
    data: qs.stringify(params, { indices: false }),
  });
}

export function deleteRole(roleId, params) {
  return request({
    url: `/api/v3/column_hybrid/douyin/${roleId}/role_delete`,
    method: "post",
    params,
  });
}

/**
 *  子账号
 */
export function getUserList(params) {
  return request.get(`/api/v3/teacher_hybrid/user_list`, { params });
}

export function getUserGroupList(params) {
  return request.get(`/api/v3/teacher_hybrid/group_list`, { params });
}

export function createUserGroup(data) {
  return request({
    url: `/api/v3/teacher_hybrid/group_create`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function updateUserGroup(groupId, data) {
  return request({
    url: `/api/v3/teacher_hybrid/${groupId}/group_update`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function deleteUserGroup(groupId) {
  return request({
    url: `/api/v3/teacher_hybrid/${groupId}/group_delete`,
    method: "post",
  });
}

export function getDepartmentTree() {
  return request.get(`/api/v3/teacher_hybrid/department_tree`);
}

export function createDepartment(data) {
  return request({
    url: `/api/v3/teacher_hybrid/department_create`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function updateDepartment(deptId, data) {
  return request({
    url: `/api/v3/teacher_hybrid/${deptId}/department_update`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function deleteDepartment(deptId) {
  return request({
    url: `/api/v3/teacher_hybrid/${deptId}/department_delete`,
    method: "post",
  });
}

export function batchAssignDepartment(data) {
  return request({
    url: `/api/v3/teacher_hybrid/department_batch_assign`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function getUserDetail(loginId) {
  return request.get(`/api/v3/teacher_hybrid/${loginId}/user_show`);
}

export function getRrjUserDetail(loginId) {
  return request.get(`/api/v3/teacher_hybrid/${loginId}/rrjuser_show`);
}

export function userCreate(data) {
  return request({
    url: `/api/v3/teacher_hybrid/user_create`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function getWecomBindingConflictList(data) {
  return request({
    url: `/api/v3/teacher_hybrid/wecom_binding_conflict_list`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function removeWecomBindingConflict(data) {
  return request({
    url: `/api/v3/teacher_hybrid/wecom_binding_conflict_remove`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function userUpdate(loginId, data) {
  return request({
    url: `/api/v3/teacher_hybrid/${loginId}/user_update`,
    method: "post",
    data: qs.stringify(data, { indices: false }),
  });
}

export function userEnable(id, params) {
  return request({
    url: `/api/v3/teacher_hybrid/${id}/user_enable`,
    method: "post",
    params,
  });
}

export function userDelete(id, params) {
  return request({
    url: `/api/v3/teacher_hybrid/${id}/user_delete`,
    method: "post",
    params,
  });
}

export function addLog(data) {
  return request({
    url: `/api/v3/teacher_hybrid/add_log_new`,
    method: "post",
    data: qs.stringify(data),
  });
}

//
export function addResource(data) {
  return request({
    url: `/api/v3/teacher_hybrid/douyin/upload_role_material`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    //这部分非常重要，否则formdata会被转格式
    // transformRequest: [
    //   function () {
    //     return data;
    //   },
    // ],
    data: data,
  });
}

// 获取授权列表
export function findAuthList(params) {
  params.dyAppid = "tt59532feec66ba0e701";
  return request.get(
    "/api/v4/planet/teacher/qualification/findAuthEntityBypartnerList",
    { params }
  );
}

export function getAllCourseCategories2() {
  return request.get(`/api/v4/planet/getAllCourseCategories2`);
}

// 提交资质授权
export function togetherAuth(data) {
  data.dyAppid = "tt59532feec66ba0e701";
  return request({
    url: "/api/v4/planet/teacher/qualification/togetherAuth",
    method: "post",
    data,
  });
}

// 更新基础信息
export function personalEntityUpdateBasicAuth(data) {
  return request({
    url: "/api/v4/planet/teacher/qualification/personalEntityUpdateBasicAuth",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

// 更新类目信息
export function personalEntityUpdateClassAuth(data) {
  return request({
    url: "/api/v4/planet/teacher/qualification/personalEntityUpdateClassAuth",
    method: "post",
    data,
  });
}

// 更新授权小程序的信息
export function personalEntityUpdateAuthletter(data) {
  return request({
    url: "/api/v4/planet/teacher/qualification/personalEntityUpdateAuthletter",
    method: "post",
    data,
  });
}

export function enableMountScope(id, userId, openid, scopeList) {
  return request({
    url: `/api/v4/planet/enableMountScope?id=${id}&userId=${userId}&openid=${openid}&scopeList=${scopeList}&dyAppid=tt59532feec66ba0e701`,
    method: "post",
  });
}

export function reableMountScope(id, scopeList) {
  return request({
    url: `/api/v4/planet/reableMountScope?id=${id}&scopeList=${scopeList}`,
    method: "post",
  });
}

export function getMountScopeList({ pageNum, pageSize }) {
  return request.get("/api/v4/planet/getMountScopeList", {
    params: {
      pageNum,
      pageSize,
      dyAppid: "tt59532feec66ba0e701",
    },
  });
}

// 同步授权状态
export function asyncMountScope(id) {
  return request({
    url: `/api/v4/planet/asyncMountScope?id=${id}`,
    method: "post",
  });
}

// 解绑并且删除
export function deleteMountScope(id) {
  return request({
    url: `/api/v4/planet/deleteMountScope?id=${id}`,
    method: "post",
  });
}

export function getXcxHoldCodeByOpenId(params) {
  return request.get(`/api/v4/dy/video/getXcxHoldCodeByOpenId`, { params });
}

export function xcxOauthAccessToken(params) {
  return request.get(`/api/v4/dy/video/xcxOauthAccessToken`, { params });
}

export function initTTAccountRecord() {
  let params = {
    dyAppid: "tt59532feec66ba0e701",
  };
  return request({
    url: "/api/v4/planet/initTTAccountRecord",
    method: "post",
    params,
  });
}

export function getAccountRecordById(id) {
  return request.get(`/api/v4/planet/getAccountRecordById?id=${id}`);
}

export function updateAccountRecordById(params) {
  return request({
    url: `/api/v4/planet/updateAccountRecordById`,
    method: "post",
    params,
  });
}

export function getDouyinList(data) {
  return request.get(`/api/v4/shop/douyin/findList`, data);
}

export function batchImportUsers(data) {
  return request({
    url: `/api/v3/teacher_hybrid/user_batch_import`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export function getHybridOperateLogPage(params) {
  return request.get(`/api/v3/hybridOperateLog/page`, { params });
}

export function getHybridOperateLogDetail(id) {
  return request.get(`/api/v3/hybridOperateLog/${id}/detail`);
}

export function reportHybridOperateLog(data) {
  return request({
    url: `/api/v3/hybridOperateLog/report`,
    method: "post",
    data: qs.stringify(data),
  });
}
